module.exports = __webpack_public_path__ + "img/dlybg01.6264e89b.png";